import { routes } from "./base/apiRoutes";
import {
	// deleteAPIResponse,
	getAPIResponse,
	postAPIResponse,
	// putAPIResponse,
} from "./base/api";

export const fetchAllDynamicProperties = async () => {
	return getAPIResponse(routes.fetchAllDynamicProperties);
};

export const fetchLooks = (id = "") => {
	let url = routes.looks;

	if (id) {
		url += "/?_id=" + id;
	}
	return getAPIResponse(url);
};

export const fetchLayouts = (id = "", roomType) => {
	let url = routes.layouts;
	url += `/?roomType=${roomType}`;

	if (id) {
		url += `&_id=${id}`;
	}

	return getAPIResponse(url);
};

export const fetchSizes = (id = "") => {
	let url = routes.sizes;

	if (id) {
		url += "/?layoutId=" + id;
	}
	return getAPIResponse(url);
};

export const createCustomer = (payload) => {
	return postAPIResponse(routes.customers, payload);
};

export const fetchRenders = ({ lookId, layoutId, sizeId, sizeString }) => {
	return getAPIResponse(
		routes.renders +
			`?lookId=${lookId}&layoutId=${layoutId}&sizeId=${sizeId}&sizeString=${sizeString}`
	);
};
